/**
 * BOOTH's platform fee on BOOTH RENT — single source of truth.
 *
 * This is the fee a barber pays on top of the rent when they reserve a chair
 * through BOOTH. It is added to the rent, never deducted from it: the shop
 * receives exactly the price it listed.
 *
 * NOT the same fee as client bookings or memberships. Those are a separate
 * rate that lives with the booking-processing model in lib/booking-fees.ts —
 * changing one must not silently change the other, which is exactly what a
 * shared "3%" scattered across eight files invited.
 *
 * It was a bare `0.03` written out in six API routes with no constant and no
 * test pinning them together, so raising it meant finding every one and hoping.
 * Import this instead; the next change is one line.
 */

/** 5% of the booth rent, added on top. */
export const BOOTH_RENT_PLATFORM_FEE_RATE = 0.05

/** For display: "5%". Keep UI copy derived from the rate, never retyped. */
export const BOOTH_RENT_PLATFORM_FEE_LABEL = `${Math.round(BOOTH_RENT_PLATFORM_FEE_RATE * 100)}%`

/**
 * Fee in cents for a rent amount in cents. Rounded once, here, so every route
 * agrees to the penny — two routes rounding independently is how a charge and
 * its later verification end up a cent apart and the confirm step rejects a
 * payment that was actually correct.
 */
export function boothRentPlatformFeeCents(rentCents: number): number {
  return Math.round(rentCents * BOOTH_RENT_PLATFORM_FEE_RATE)
}
